import { makeStyles } from 'tss-react/mui';

const useStylesFieldCheckbox: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldCheckboxLabelNoOffset: {
    margin: '0 !important',
  },
  fieldCheckbox: {
    padding: '10px !important',
    top: '-1px !important',
    marginLeft: '10px !important',
  },
  fieldCheckboxNoOffset: {
    marginLeft: '0 !important',
  },
  fieldCheckboxDefault: {
    top: '0 !important',
  },
  error: {
    color: theme.palette.error.main,
    '& > p': {
      color: `${theme.palette.error.main} !important`,
    },
  },
}));

export default useStylesFieldCheckbox;
